import { GetVenueSurchargesType as ApiVenueSurchargesType } from 'src/api/generated/touring/types';
import { mapMoneyType } from '../../../common';
import { VenueSurchargesType } from '../../types';

export const mapVenueSurchargesType = (
  apiType: ApiVenueSurchargesType
): VenueSurchargesType => {
  return {
    facilityFee: apiType.facilityFee ? mapMoneyType(apiType.facilityFee) : null,
    publicTransportFee: apiType.publicTransportFee
      ? mapMoneyType(apiType.publicTransportFee)
      : null,
    notes: apiType.notes,
  };
};
